import { render, staticRenderFns } from "./HistoryItemTypeComplete.vue?vue&type=template&id=2ea2fe51&scoped=true&"
import script from "./HistoryItemTypeComplete.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeComplete.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeComplete.vue?vue&type=style&index=0&id=2ea2fe51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2fe51",
  null
  
)

export default component.exports